



























































































import CompSelectBox from '@/components/common/CompSelectBox.vue';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import {firstDayOfMonth, getBeforeDate, getFirstAndEndDay, changeDateFormat} from '@/utils/dateUtils';
import {addClass, removeClass} from '@/utils/classUtils';
import {i18nListByKey} from '@/utils/i18n';
import {formatCurrency} from '@/utils/formatUtils';
import {Vue, Component} from 'vue-property-decorator';
import {State, namespace} from 'vuex-class';
import {Mall, GetSalesRequest, GetSalesExcelRequest} from 'supporter';
import {createExcel} from '@/components/common/grid/ExcelCreateUtil';
import ExcelCreateButton from '@/components/common/grid/ExcelCreateButton.vue';
import {toI18n} from '@/utils/commonUtils';
const mallModule = namespace('mall');
const termsModule = namespace('terms');
@Component({
  components: {CompSelectBox, PeriodDateCalendar, ItemTable, ExcelCreateButton}
})
export default class SettlementPartner extends Vue {
  @termsModule.Mutation('SET_NCPLAYERISEXIST') private setPopIsExist!: (isExist: boolean) => void;
  @termsModule.Mutation('SET_NCPLAYERISSHOW') private setPopIsShow!: (isExist: boolean) => void;
  @termsModule.Mutation('SET_POPINFO') private setPopInfo!: (popInfo: {title: string, subStyle: string, noticeBox: string}) => void;
  // 쇼핑몰
  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<any>;
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private mallNo: string = '';
  private get mallList() {
    let res: any = [];
    if (this.malls) {
      this.malls.forEach((mall) => {
        res.push({
          value: mall.mallNo.toString(),
          name: mall.mallName
        });
      });
    }
    return res;
  }

  // 파트너구분
  private partnerType: string = '';
  private partnerTypes = [
    {
      value: '',
      name: 'COMMON_ALL'
    },
    {
      value: 'DOMESTIC',
      name: 'SETTLEMENT_PARTNER_TYPE_DOMESTIC'
    },
    {
      value: 'OVERSEAS',
      name: 'SETTLEMENT_PARTNER_TYPE_OVERSEAS'
    }
  ];

  // 기간
  private periodType: string = 'monthSelect';
  private periodTypes = [
    {
      value: 'monthSelect',
      name: 'SETTLEMENT_PARTNER_MONTH_SELECT'
    },
    {
      value: 'periodSelect',
      name: 'SETTLEMENT_PARTNER_PERIOD_SELECT'
    }
  ];
  private year: number = new Date().getFullYear();
  private beginYear: number = new Date().getFullYear() - 5 >= 2018 ? new Date().getFullYear() - 5 : 2018;
  private get yearList() {
    let years = [];
    let todayYear = new Date().getFullYear();
    for (let i = this.beginYear; i <= todayYear; i++) {
      years.push({
        value: i,
        name: `${i} ${this.$t('COMMON_YEAR')}`
      });
    }
    return years;
  }
  private month: number = new Date().getMonth() + 1;
  private get monthList() {
    let months = [];
    for (let i = 1; i <= 12; i++) {
      months.push({
        value: i,
        name: `${i} ${this.$t('COMMON_MONTH')}`
      });
    }
    return months;
  }
  private startDate: string = firstDayOfMonth();
  private endDate: string = getBeforeDate(1);
  private periodOption = {
    havePeriodBtn: false,
    dateType: 'Ymd'
  };

  // 조회
  private pageSize: number = 50;
  private totalCount: number = 0;

  private salesRequest: GetSalesRequest = null;
  private get settlementDailySalesExtraInfo() {
    const startYmd = this.salesRequest?.params?.startDateTime ?? '';
    const endYmd = this.salesRequest?.params?.endDateTime ?? '';

    return `${changeDateFormat(startYmd, 'YYYYMMDD')}_${changeDateFormat(endYmd, 'YYYYMMDD')}`
  }

  private async search(page: number = 1, size?: number) {
    if (size) {
      this.pageSize = size;
    }
    let startDateTime = '';
    let endDateTime = '';
    if (this.periodType === 'monthSelect') {
      if (this.year === new Date().getFullYear() && this.month === new Date().getMonth() + 1) {
        startDateTime = firstDayOfMonth();
        endDateTime = getBeforeDate(1);
      } else {
        let tempDates = getFirstAndEndDay(this.year, this.month);
        startDateTime = tempDates.startYmd;
        endDateTime = tempDates.endYmd;
      }
    } else {
      startDateTime = this.startDate;
      endDateTime = this.endDate;
    }
    this.downloadInfo = {
      totalSearchYmd: startDateTime + '~' + endDateTime,
      startDate: startDateTime,
      endDate: endDateTime,
      mallNo: Number(this.mallNo)
    };
    startDateTime += ' 00:00:00';
    endDateTime += ' 23:59:59';
    this.salesRequest = {
      params: {
        mallNo: Number(this.mallNo),
        startDateTime,
        endDateTime,
        page,
        size: this.pageSize
      }
    };
    if (this.partnerType !== '') {
      this.salesRequest.params.partnerType = this.partnerType as any;
      this.downloadInfo.partnerType = this.partnerType;
    }
    const {data} = await this.$api.getSales(this.salesRequest);
    // 매출 합계
    this.totalSales = this.formatterData('total', data.totalSalesHistory[0]);

    // 일별 매출 상세
    this.dailySales = this.formatterData('daily', data.dailySalesHistory.contents);
    this.totalCount = data.dailySalesHistory.totalCount;
    this.dailyGridProps.options.pageOptions.page = page;
    this.dailyGridProps.options.pageOptions.perPage = this.pageSize;
    this.dailyGridProps.options.pageOptions.totalCount = data.dailySalesHistory.totalCount;
  }

  private formatterData(type: string, data: any): any {
    if (type === 'total') {
      if (data === undefined) {
        return [];
      } else {
        return [
          {
            type,
            startDate: this.downloadInfo.startDate,
            endDate: this.downloadInfo.endDate,
            searchYmd: this.downloadInfo.totalSearchYmd,
            orderCnt: data.orderCnt,
            refundCnt: data.refundCnt,
            salesAmt: formatCurrency(data.salesAmt),
            commissionAmt: formatCurrency(data.commissionAmt),
            deliveryAmt: formatCurrency(data.deliveryAmt),
            partnerDiscountAmt: formatCurrency(data.partnerDiscountAmt),
            deductedAmt: formatCurrency(data.salesAmt - data.commissionAmt + data.deliveryAmt - data.partnerDiscountAmt - data.settlementAmt),
            settlementAmt: formatCurrency(data.settlementAmt)
          }
        ];
      }
    } else {
      return data.map((item: any) => {
        return {
          type,
          startDate: item.createDate,
          endDate: item.createDate,
          searchYmd: item.createDate,
          orderCnt: item.orderCnt,
          refundCnt: item.refundCnt,
          salesAmt: formatCurrency(item.salesAmt),
          commissionAmt: formatCurrency(item.commissionAmt),
          deliveryAmt: formatCurrency(item.deliveryAmt),
          partnerDiscountAmt: formatCurrency(item.partnerDiscountAmt),
          deductedAmt: formatCurrency(item.salesAmt - item.commissionAmt + item.deliveryAmt - item.partnerDiscountAmt - item.settlementAmt),
          settlementAmt: formatCurrency(item.settlementAmt)
        };
      });
    }
  }

  // 초기화
  private reset() {
    this.mallNo = this.malls[0].mallNo.toString();
    this.partnerType = '';
    this.periodType = 'monthSelect';
    this.year = new Date().getFullYear();
    this.month = new Date().getMonth() + 1;
    this.startDate = firstDayOfMonth();
    this.endDate = getBeforeDate(1);
  }

  public pDI18n(needToI18nStr: string): string {
    return toI18n(this.$t('SETTLEMENT_PARTNER_' + needToI18nStr));
  }
  public customColumnHeader = {
    columns: [
      {
        name: 'deductedAmt',
        renderer: ({columnInfo}: any) => {
          const div = document.createElement('div');
          const span = document.createElement('span');
          span.innerText = columnInfo.header;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'help';
          button.style.cssText = 'background: url(/static/ncp/css/img/sp.png) no-repeat -76px 0;';
          button.addEventListener('mousedown', (e): void => {
            const popInfo = {
              title: this.pDI18n('DEDUCTED_AMT_TITLE'),
              subStyle: 'width:640px; max-height:800px; scroll-y:auto',
              noticeBox: `
                <div class="notice_box noIcon">
                  <ul>
                    <li>${this.pDI18n('DEDUCTED_AMT_1')}</li>
                  </ul>
                </div>`
            };
            this.setPopInfo(popInfo);
            this.setPopIsShow(true);
            e.preventDefault();
            e.stopPropagation();
          });
          div.append(span, button);
          return {
            getElement(): any {
              return div;
            },
            render(): void {
              div.append(span, button);
            }
          };
        }
      }
    ]
  };

  // 매출 합계
  private gridColumns = [
    {
      header: 'SETTLEMENT_PARTNER_HEADER_SEARCH_YMD',
      name: 'searchYmd',
      align: 'center',
      minWidth: 150
    },
    {
      header: 'SETTLEMENT_PARTNER_HEADER_ORDER_CNT',
      name: 'orderCnt',
      align: 'center',
      minWidth: 80
    },
    {
      header: 'SETTLEMENT_PARTNER_HEADER_REFUND_CNT',
      name: 'refundCnt',
      align: 'center',
      minWidth: 80
    },
    {
      header: 'SETTLEMENT_PARTNER_HEADER_SALES_AMT',
      name: 'salesAmt',
      align: 'right',
      minWidth: 100
    },
    {
      header: 'SETTLEMENT_PARTNER_HEADER_COMMISSION_AMT',
      name: 'commissionAmt',
      align: 'right',
      minWidth: 100
    },
    {
      header: 'SETTLEMENT_PARTNER_HEADER_DELIVERY_AMT',
      name: 'deliveryAmt',
      align: 'right',
      minWidth: 100
    },
    {
      header: 'SETTLEMENT_PARTNER_HEADER_PARTNER_DISCOUNT_AMT',
      name: 'partnerDiscountAmt',
      align: 'right',
      minWidth: 180
    },
    {
      header: 'SETTLEMENT_PARTNER_HEADER_DEDUCTED_AMT',
      name: 'deductedAmt',
      align: 'right',
      minWidth: 100
    },
    {
      header: 'SETTLEMENT_PARTNER_HEADER_SETTLEMENT_AMT',
      name: 'settlementAmt',
      align: 'right',
      minWidth: 180
    },
    {
      header: 'COMMON_DETAILS',
      name: 'excelBtn',
      align: 'center',
      minWidth: 100,
      formatter: (cell: any) => {
        return `<button type="button" class="excelBtn" data-type="${cell.row.type}" data-start-date="${cell.row.startDate}" data-end-date="${cell.row.endDate}"></span>${window.$t(
          'COMMON_DOWNLOAD'
        )}</button>`;
      }
    }
  ];
  private totalSales: any[] = [];
  private totalOption = {
    name: 'totalSalesGrid',
    nonDataBodyHeight: 100,
    haveDataBodyHeight: 34,
    haveRigthBtn: false,
    onLoadSearch: false
  };
  private totalGridProps = {
    options: {
      columnOptions: {
        minWidth: 50,
        resizable: true
      },
      isInitialRequest: true,
      useClientSort: false,
      scrollX: false,
      scrollY: false,
      minBodyHeight: 34
    },
    columns: this.gridColumns,
    header: {}
  };
  // 일별 매출 상세
  private dailySales: any[] = [];
  private dailyOption = {
    name: 'dailySalesGrid',
    onLoadSearch: false,
    haveConfigBtn: false,
    haveExcelDownBtn: false,
    pageSize: '50'
  };
  private dailyGridProps = {
    options: {
      columnOptions: {
        minWidth: 50,
        resizable: true
      },
      displayRowCount: 30,
      isInitialRequest: true,
      useClientSort: false,
      pageOptions: {
        perPage: 50,
        page: 1,
        totalCount: 0
      }
    },
    copyOptions: {
      useFormattedValue: true
    },
    columns: this.gridColumns,
    header: {}
  };

  // 다운로드
  private downloadInfo: any = {
    totalSearchYmd: '',
    startDate: '',
    endDate: '',
    mallNo: 0,
    partnerType: ''
  };
  private async download(e: any) {
    let startDateTime = $(e.target).data('startDate') + ' 00:00:00';
    let endDateTime = $(e.target).data('endDate') + ' 23:59:59';
    let createExcelFileQuery: any = {
      mallNo: this.downloadInfo.mallNo,
      startDateTime,
      endDateTime
    };
    if (this.downloadInfo.partnerType !== '') {
      createExcelFileQuery.partnerType = this.downloadInfo.partnerType;
    }
    let startYmd = $(e.target).data('startDate').replace(/-/g, '');
    if ($(e.target).data('type') === 'total') {
      let endYmd = $(e.target).data('endDate').replace(/-/g, '');
      createExcel(this, this.dailySales.length > 0, createExcelFileQuery, 'PREMIUM_SETTLEMENT_TOTAL_SALE', `${startYmd}_${endYmd}`);
    } else {
      createExcel(this, this.dailySales.length > 0, createExcelFileQuery, 'PREMIUM_SETTLEMENT_DAILY_SALE', `${startYmd}`);
    }
  }
  private async downloadOld(e: any) {
    let startDateTime = $(e.target).data('startDate') + ' 00:00:00';
    let endDateTime = $(e.target).data('endDate') + ' 23:59:59';
    let request: GetSalesExcelRequest = {
      params: {
        mallNo: this.downloadInfo.mallNo,
        startDateTime,
        endDateTime
      }
    };
    if (this.downloadInfo.partnerType !== '') {
      request.params.partnerType = this.downloadInfo.partnerType as any;
    }
    const {data} = await this.$api.getSalesExcel(request);
    let fileName = '';
    let startYmd = $(e.target).data('startDate').replace(/-/g, '');
    if ($(e.target).data('type') === 'total') {
      let endYmd = $(e.target).data('endDate').replace(/-/g, '');
      fileName = `${window.$t('SETTLEMENT_PARTNER_EXCEL_NAME_TOTAL_SALES')}_${startYmd}_${endYmd}_`;
    } else {
      fileName = `${window.$t('SETTLEMENT_PARTNER_EXCEL_NAME_DAILY_SALES')}_${startYmd}_`;
    }
    fileName += changeDateFormat(new Date(), 'YYYYMMDDHHmmss') + '.xlsx';
    const myBlob = new Blob([data], {type: 'application/octet-stream'});
    const qrUrl = window.URL.createObjectURL(myBlob);
    const a = document.createElement('a');
    const event = new MouseEvent('click');
    a.download = fileName;
    a.href = qrUrl;
    a.dispatchEvent(event);
    window.URL.revokeObjectURL(qrUrl);
  }

  // utils
  private emptyToDash(value: any) {
    if (value === undefined || value === null || value === '' || value === 0) {
      return '-';
    }
    return value;
  }
  private emptyToDashRate(value: any) {
    if (value === undefined || value === null || value === '' || value === 0) {
      return '-';
    }
    return value + '%';
  }

  private async mounted() {
    await this.fetchMalls();
    this.mallNo = this.malls[0].mallNo.toString();
    await this.search(1);
  }
  private created() {
    const newtotalGridProps = { ...this.totalGridProps };
    newtotalGridProps.header = { ...this.customColumnHeader };
    this.totalGridProps = newtotalGridProps;
    const newdailyGridProps = { ...this.dailyGridProps };
    newdailyGridProps.header = { ...this.customColumnHeader };
    this.dailyGridProps = newdailyGridProps;
    this.setPopIsExist(true);
    this.$nextTick(() => {
      addClass(document.getElementById('container') as HTMLElement, 'bg_white');
    });
    this.gridColumns = i18nListByKey(this, this.gridColumns, 'header');
    $('body').on('click', '.excelBtn', $.proxy(this.download, this));
  }
  private destroyed() {
    removeClass(document.getElementById('container') as HTMLElement, 'bg_white');
  }
}
